import { render, staticRenderFns } from "./ClientBasicInfo.vue?vue&type=template&id=5e550527&scoped=true"
import script from "./ClientBasicInfo.vue?vue&type=script&lang=js"
export * from "./ClientBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./ClientBasicInfo.vue?vue&type=style&index=0&id=5e550527&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e550527",
  null
  
)

export default component.exports